import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ThankYou from "@/views/ThankYou";
import Register from "@/views/Register";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Root"
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/thankyou",
    name: "ThankYou",
    component: ThankYou
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
